/**
 * Returns the default market definition to be used
 *
 * @returns {{name: string, market_tz: string, hour_aligned: boolean, rules: Array}}
 */
var defaultMarketDef = {
    name: 'marketDefPt',
    market_tz: 'Europe/London',
    hour_aligned: false,
    rules: [{ dayofweek: 1, open: '09:00', close: '17:00' }],
};
export { defaultMarketDef };
//# sourceMappingURL=marketDef.js.map